(function () {
  'use strict';

  var loader = document.currentScript;
  if (!loader || window.CernirFeatureLoader) return;

  var config = loader.dataset;
  var promises = {};

  function loadStyle(key, url) {
    if (!url || promises[key]) return promises[key] || Promise.resolve();
    if (document.querySelector('[data-cernir-asset="' + key + '"]')) {
      promises[key] = Promise.resolve();
      return promises[key];
    }
    promises[key] = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.cernirAsset = key;
      link.onload = resolve;
      link.onerror = function (error) { forget(key, link); reject(error); };
      document.head.appendChild(link);
    });
    return promises[key];
  }

  // A failed request must not stay cached: drop it so the next open (or observer pass) tries again.
  function forget(key, element) {
    delete promises[key];
    if (element && element.parentNode) element.parentNode.removeChild(element);
  }

  function loadScript(key, url) {
    if (!url || promises[key]) return promises[key] || Promise.resolve();
    promises[key] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.dataset.cernirAsset = key;
      script.onload = resolve;
      script.onerror = function (error) { forget(key, script); reject(error); };
      document.head.appendChild(script);
    });
    return promises[key];
  }

  function contains(scope, selector) {
    return Boolean(scope && ((scope.matches && scope.matches(selector)) || (scope.querySelector && scope.querySelector(selector))));
  }

  function loadStrapSizing(scope) {
    return Promise.all([
      loadStyle('strap-sizing-css', config.strapSizingCss),
      loadScript('strap-sizing-js', config.strapSizingJs)
    ]).then(function () {
      if (window.CERNIR && window.CERNIR.StrapSizing) window.CERNIR.StrapSizing.init(scope || document);
      return window.CERNIR && window.CERNIR.StrapSizing;
    });
  }

  // Calculators inside a closed dialog (the product page and Customise length guides, the builder's length guide)
  // load when that dialog is about to open: see onGuideIntent and custom-strap-cd.js openLengthGuide.
  // Calculators shown inline (size guide pages) still load straight away.
  function hasOpenStrapCalculator(scope) {
    var hosts = [];
    if (scope && scope.matches && scope.matches('[data-cernir-strap-calculator]')) hosts.push(scope);
    if (scope && scope.querySelectorAll) hosts = hosts.concat(Array.from(scope.querySelectorAll('[data-cernir-strap-calculator]')));
    return hosts.some(function (host) { return !host.closest('[aria-hidden="true"], [hidden]'); });
  }

  function loadCartOrchestrator() {
    return loadScript('cart-orchestrator-js', config.cartOrchestratorJs);
  }

  function activate(scope) {
    if (contains(scope, '.cvp-wrapper[data-product-form-id]')) {
      Promise.all([loadStyle('product-options-css', config.productOptionsCss), loadCartOrchestrator()]).then(function () {
        return loadScript('product-options-js', config.productOptionsJs);
      }).then(function () {
        if (window.CernirProductOptions) window.CernirProductOptions.init(scope);
      }).catch(function (error) { console.error('Unable to load CERNIR product options.', error); });
    }

    if (contains(scope, '[data-cernir-customise]')) {
      Promise.all([loadStyle('customise-css', config.customiseCss), loadCartOrchestrator()]).then(function () {
        return loadScript('customise-js', config.customiseJs);
      }).then(function () {
        if (window.CernirCustomise) window.CernirCustomise.init(scope);
      }).catch(function (error) { console.error('Unable to load CERNIR customisation.', error); });
    }

    if (hasOpenStrapCalculator(scope)) {
      loadStrapSizing(scope).catch(function (error) { console.error('Unable to load CERNIR strap sizing.', error); });
    }

    if (contains(scope, '[data-cernir-bundle-id]')) {
      Promise.all([
        loadStyle('cart-bundle-css', config.cartBundleCss),
        loadScript('cart-bundle-js', config.cartBundleJs)
      ]).catch(function (error) {
        console.error('Unable to load CERNIR cart bundle controls.', error);
      });
    }
  }

  // Country selector: the ~237 options live in sections/cernir-country-list.liquid and are fetched the first time
  // someone points at, focuses or clicks a country toggle (snippets/localization-selector.liquid renders a placeholder).
  var countryListRequest = null;

  function countryListSlot(toggle) {
    var popover = document.getElementById(toggle.getAttribute('aria-controls') || '');
    return popover && popover.querySelector('[data-cernir-country-list]');
  }

  function loadCountryLists() {
    if (!countryListRequest) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      countryListRequest = fetch(root + '?section_id=cernir-country-list', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var list = new DOMParser().parseFromString(html, 'text/html').querySelector('x-listbox');
          if (!list) throw new Error('country list missing from response');
          document.querySelectorAll('[data-cernir-country-list]').forEach(function (slot) {
            var popover = slot.closest('x-popover');
            slot.replaceWith(document.importNode(list, true));
            // If the popover opened before the list arrived, move focus to the selected country as it would on open.
            if (popover && popover.hasAttribute('open')) {
              var selected = popover.querySelector('[aria-selected="true"]');
              if (selected) selected.focus({ preventScroll: false });
            }
          });
        })
        .catch(function (error) {
          countryListRequest = null; // allow a retry on the next interaction
          console.error('Unable to load the CERNIR country list.', error);
        });
    }
    return countryListRequest;
  }

  function onCountryToggleIntent(event) {
    var toggle = event.target && event.target.closest && event.target.closest('.localization-toggle[aria-controls]');
    if (toggle && countryListSlot(toggle)) loadCountryLists();
  }

  function onGuideIntent(event) {
    var trigger = event.target && event.target.closest && event.target.closest('.cvp-guide-button[data-modal], .cvp-guide-button-link[data-modal]');
    var modal = trigger && document.getElementById(trigger.dataset.modal);
    if (!modal || !modal.querySelector('[data-cernir-strap-calculator]:not([data-strap-calculator-ready])')) return;
    loadStrapSizing(modal).catch(function (error) { console.error('Unable to load CERNIR strap sizing.', error); });
  }

  // The add-to-cart button stays disabled until the variant picker takes over (snippets/buy-buttons.liquid). If the
  // picker script failed to load, touching the picker or the product form tries again, so the customer can still buy.
  function onPickerIntent(event) {
    var target = event.target && event.target.closest && event.target.closest('.cvp-wrapper[data-product-form-id], product-form');
    if (!target || promises['product-options-js']) return;
    var picker = target.matches('.cvp-wrapper') ? target : null;
    if (!picker) {
      var form = target.querySelector('form[id]');
      picker = form && Array.from(document.querySelectorAll('.cvp-wrapper[data-product-form-id]')).find(function (candidate) {
        return candidate.dataset.productFormId === form.id;
      });
    }
    if (picker && picker.dataset.cvpInitialized !== 'true') activate(picker);
  }

  ['pointerover', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, onCountryToggleIntent, { capture: true, passive: true });
    document.addEventListener(type, onGuideIntent, { capture: true, passive: true });
    document.addEventListener(type, onPickerIntent, { capture: true, passive: true });
  });

  var pendingNodes = [];
  var activationFrame = 0;
  var observing = false;

  function flushPendingNodes() {
    activationFrame = 0;
    var nodes = pendingNodes;
    pendingNodes = [];
    nodes.forEach(activate);
  }

  function queueActivation(node) {
    if (!contains(node, '.cvp-wrapper[data-product-form-id], [data-cernir-customise], [data-cernir-strap-calculator], [data-cernir-bundle-id]')) return;
    pendingNodes.push(node);
    if (!activationFrame) activationFrame = window.requestAnimationFrame(flushPendingNodes);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        // Skip nodes rendered by the custom strap builder: none of the watched features live inside it.
        if (node.nodeType === 1 && !node.closest('[data-cs-cd]')) queueActivation(node);
      });
    });
  });

  function startObserver() {
    if (observing || !document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    observing = true;
  }

  function stopObserver() {
    if (!observing) return;
    observer.disconnect();
    observing = false;
  }

  function handleVisibilityChange() {
    if (document.hidden) stopObserver();
    else {
      startObserver();
      activate(document);
    }
  }

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.CernirFeatureLoader = {
    activate: activate,
    disconnect: stopObserver,
    loadStrapSizing: loadStrapSizing
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      activate(document);
    }, { once: true });
  } else {
    startObserver();
    activate(document);
  }

})();
